import { render, staticRenderFns } from "./_StartOrResumeForm.vue?vue&type=template&id=2597f1e2&"
import script from "./_StartOrResumeForm.vue?vue&type=script&lang=js&"
export * from "./_StartOrResumeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports